if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      //this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);        

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          let jsonRecommended = JSON.parse(this.submitButton.closest('.product').dataset.recommended);

          if (jsonRecommended) {
            fetch('/cart.js').then(response => response.json()).then(cart => {
                        const allProductsInCart = jsonRecommended.every(product => cart.items.some(item => item.product_id === product.id))                                             
                        let relatedProductsSkip = localStorage.getItem('relatedProductsSkip');
                        if (relatedProductsSkip !== 'true' && !allProductsInCart) {
                            let optionEnded = jsonRecommended.length > 1 ? 's' : '';
                            document.body.insertAdjacentHTML('beforeend',
                              `<div class="related-products--background">
                                  <div class="related-products--modal">
                                    <button type="button" class="drawer__close modal__close-button link focus-inset modal-close-button" onclick="this.closest('.related-products--background').remove()" aria-label="Close">					
                                      <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 14 14">
                                        <rect y="12.728" width="18" height="1.5" transform="rotate(-45 0 12.728)" fill="currentColor"></rect>
                                        <rect x="1.06055" width="18" height="1.5" transform="rotate(45 1.06055 0)" fill="currentColor"></rect>
                                      </svg>
                                    </button>
                                    <p>This product requires a liner, please add one of the ${jsonRecommended.length} option${optionEnded} to your cart before continuing or <b>Skip</b> button</p>
                                    <div class="related-products--wrapper">
                                    ${jsonRecommended.map(product => {
                                        let thisProductInCart = cart.items.some(item => item.product_id === product.id) ? `<b>This product has already been added to cart</b>` : ``;
                                        return `<div class="related-products--item">
                                                    <a class="full-unstyled-link" href="/products/${product.handle}" target="_blank">
                                                      <img class="related-products--image" src="${product.featured_image}">
                                                    </a>
                                                    <h2 class="related-products--title">
                                                        <a class="full-unstyled-link link-hover-arrow" href="/products/${product.handle}" target="_blank">
                                  						${product.title}
                                  						<svg class="icon icon-button-arrow" width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M9.33716 3.345L2.16466 10.5175L0.986328 9.33917L8.15799 2.16667H1.83716V0.5H11.0038V9.66667H9.33716V3.345Z" fill="currentColor"></path>
                                                          </svg>                                                  
                                                        </a>
                                                        ${thisProductInCart}
                                                    </h2>
                                                </div>`;
                                    }).join('')}
                                    </div>
                                    <button class="button button--primary related-products--button">
                                      <span>
                                        <span>Skip</span>
                                        <span>Skip</span>
                                      </span>
                                    </button>
                                </div>
                              </div>`
                            )
                        }
                        
                      }) 
          }

          /*let productList1 = window.productList1, productList2 = window.productList2;        
          if (productList1 && productList2) {
              productList1.some(product1 => {
                  if (response.product_id === product1.id) {
                      fetch('/cart.js').then(response => response.json()).then(cart => {
                        const allProductsInCart = productList2.every(product => cart.items.some(item => item.product_id === product.id))                                             
                        let relatedProductsSkip = localStorage.getItem('relatedProductsSkip');
                        if (relatedProductsSkip !== 'true' && !allProductsInCart) {
                            let optionEnded = productList2.length > 1 ? 's' : '';
                            document.body.insertAdjacentHTML('beforeend',
                              `<div class="related-products--background">
                                  <div class="related-products--modal">
                                    <button type="button" class="drawer__close modal__close-button link focus-inset modal-close-button" onclick="this.closest('.related-products--background').remove()" aria-label="Close">					
                                      <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 14 14">
                                        <rect y="12.728" width="18" height="1.5" transform="rotate(-45 0 12.728)" fill="currentColor"></rect>
                                        <rect x="1.06055" width="18" height="1.5" transform="rotate(45 1.06055 0)" fill="currentColor"></rect>
                                      </svg>
                                    </button>
                                    <p>This product requires a liner, please add one of the ${productList2.length} option${optionEnded} to your cart before continuing or <b>Skip</b> button</p>
                                    <div class="related-products--wrapper">
                                    ${productList2.map(product2 => {
                                        let thisProductInCart = cart.items.some(item => item.product_id === product2.id) ? `<b>This product has already been added to cart</b>` : ``;
                                        return `<div class="related-products--item">
                                                    <a class="full-unstyled-link" href="/products/${product2.handle}" target="_blank">
                                                      <img class="related-products--image" src="${product2.featured_image}">
                                                    </a>
                                                    <h2 class="related-products--title">
                                                        <a class="full-unstyled-link link-hover-arrow" href="/products/${product2.handle}" target="_blank">
                                  						${product2.title}
                                  						<svg class="icon icon-button-arrow" width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M9.33716 3.345L2.16466 10.5175L0.986328 9.33917L8.15799 2.16667H1.83716V0.5H11.0038V9.66667H9.33716V3.345Z" fill="currentColor"></path>
                                                          </svg>                                                  
                                                        </a>
                                                        ${thisProductInCart}
                                                    </h2>
                                                </div>`;
                                    }).join('')}
                                    </div>
                                    <button class="button button--primary related-products--button">
                                      <span>
                                        <span>Skip</span>
                                        <span>Skip</span>
                                      </span>
                                    </button>
                                </div>
                              </div>`
                            )
                        }
                        
                      })                    
                      return
                  }
              })
          }*/

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);               
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          //this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

document.addEventListener('click', event => {
  if (event.target.closest('.related-products--button')) {
    event.target.closest('.related-products--background').remove()
    localStorage.setItem('relatedProductsSkip', true)
  }
})